// Parser de importação compartilhado entre a lista de bloqueio e a lista de
// sempre enviar. Extrai {phone, name} de QUALQUER formato (lista solta, uma
// coluna, ou CSV inteiro de SGP/IXC/ISPFY), validando telefone BR e ignorando
// CNPJ, CEP, IP, datas e MACs. Mantido sem estado pra ser fácil de testar/reusar.

export function normalizePhone(p) {
  return String(p || '').replace(/@s\.whatsapp\.net$/i, '').replace(/@c\.us$/i, '').replace(/\D/g, '')
}

// Valida um telefone BR e devolve o número NACIONAL (10 fixo / 11 móvel, com DDD)
// ou null. Rejeita CNPJ (14), CEP/IP/datas (8), IE (9) e a maioria dos MACs.
export function nationalBrPhone(raw) {
  let d = String(raw || '').replace(/\D/g, '')
  if (!d) return null
  if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2)
  if (d.length === 11 && Number(d.slice(0, 2)) >= 11 && d[2] === '9') return d // celular
  if (d.length === 10 && Number(d.slice(0, 2)) >= 11 && /[2-5]/.test(d[2])) return d // fixo
  return null
}

const NAME_HINTS = ['cliente_nome', 'nome', 'name', 'razao', 'fantasia']
const PHONE_HINTS = ['telefone', 'telefones', 'celular', 'whatsapp', 'phone', 'fone', 'cliente_telefones']

function detectDelim(line) {
  const counts = { ',': 0, ';': 0, '\t': 0 }
  for (const ch of line) if (counts[ch] !== undefined) counts[ch]++
  return [',', ';', '\t'].reduce((best, d) => (counts[d] > counts[best] ? d : best), ',')
}

// Parser de linha CSV que respeita aspas (campos com vírgula interna, ex.: ISPFY).
function parseCsvLine(line, delim) {
  const out = []
  let cur = ''
  let q = false
  for (let i = 0; i < line.length; i++) {
    const c = line[i]
    if (q) {
      if (c === '"') { if (line[i + 1] === '"') { cur += '"'; i++ } else q = false }
      else cur += c
    } else if (c === '"') q = true
    else if (c === delim) { out.push(cur); cur = '' }
    else cur += c
  }
  out.push(cur)
  return out.map((s) => s.trim())
}

// Extrai {phone, name} de QUALQUER formato. Se detecta cabeçalho (SGP/IXC/ISPFY),
// mira só a coluna de telefone — assim CNPJ/CEP/IP/MAC nem são olhados.
export function parseImport(text, addDdi) {
  const clean = String(text || '').replace(/^﻿/, '')
  const lines = clean.split(/\r?\n/).filter((l) => l.trim())
  if (!lines.length) return { items: [], valid: 0, invalid: 0, duplicates: 0 }

  const delim = detectDelim(lines[0])
  const header = parseCsvLine(lines[0], delim).map((h) => h.toLowerCase().replace(/^﻿/, ''))
  const phoneIdx = header.findIndex((h) => PHONE_HINTS.some((p) => h.includes(p)))
  const looksHeader = phoneIdx >= 0 || header.some((h) => NAME_HINTS.includes(h))
  let nameIdx = -1
  if (looksHeader) {
    nameIdx = header.findIndex((h) => NAME_HINTS.includes(h))
    if (nameIdx === -1) nameIdx = header.findIndex((h) => h.includes('nome'))
  }

  const dataLines = looksHeader ? lines.slice(1) : lines
  const seen = new Set()
  const items = []
  let invalid = 0
  let duplicates = 0

  const addPhone = (raw, name) => {
    const digits = String(raw).replace(/\D/g, '')
    if (!digits) return
    const nat = nationalBrPhone(digits)
    if (!nat) { if (digits.length >= 8 && digits.length <= 13) invalid++; return }
    const full = addDdi ? '55' + nat : nat
    if (seen.has(full)) { duplicates++; return }
    seen.add(full)
    items.push({ phone: full, name: name && !/\d/.test(name) ? name.trim() : '' })
  }

  for (const line of dataLines) {
    const fields = parseCsvLine(line, delim)
    if (looksHeader && phoneIdx >= 0) {
      const name = nameIdx >= 0 ? (fields[nameIdx] || '') : ''
      const cell = fields[phoneIdx] || ''
      for (const part of cell.split(/[,;/]/)) if (/\d/.test(part)) addPhone(part, name)
    } else {
      const name = fields.find((f) => f && !/\d/.test(f)) || ''
      for (const part of fields) for (const sub of String(part).split(/[,;/]/)) if (/\d/.test(sub)) addPhone(sub, name)
    }
  }
  return { items, valid: items.length, invalid, duplicates }
}

// Agrupa por nome IGUAL (normalizado). Sem nome → cada número é seu próprio grupo.
export function groupByName(list) {
  const groups = new Map()
  for (const it of list) {
    const nm = (it.name || '').trim()
    const key = nm ? `n:${nm.toUpperCase()}` : `p:${it.phone}`
    if (!groups.has(key)) groups.set(key, { key, name: nm, items: [] })
    groups.get(key).items.push(it)
  }
  return [...groups.values()]
}
